import type {
  CheckType,
  ProfileDataCheckReason,
  MonetaryVerificationCheckStatus
} from '@percent/admin-dashboard/api/actions/monetaryVerifications/monetaryVerifications.types'

export type SubmitCheckModalProps = {
  isOpen: boolean
  onClose: () => void
  partnerName?: string
  organisationName?: string
  onSubmit: (formData: SubmitCheckFormValues) => void
  isPending: boolean
  submitCheckStatus: SubmitCheckResult | null
  checkType: CheckType
  checkStatus?: MonetaryVerificationCheckStatus
  checkTitle: string
}

export type SubmitCheckFormValues = {
  outcome: SubmitCheckOutcome
  rejectionReason: string
  customRejectionReason?: string
  isMistakeCorrection?: boolean
}

export enum SubmitCheckOutcome {
  APPROVE = 'approve',
  REJECT = 'reject'
}

export enum RejectionReason {
  CUSTOM_REASON = 'customReason'
}

export type RejectionReasons = ProfileDataCheckReason | RejectionReason

export type RejectionReasonOption = {
  label: string
  value: RejectionReasons
}

export enum SubmitCheckResult {
  SUCCESS = 'success',
  ERROR = 'error'
}
